export function buildQueryParams(params: object): Record<string, string> {
  return Object.fromEntries(
    Object.entries(params)
      .filter(([, v]) => v !== undefined && v !== null && v !== '' && v !== 0)
      .map(([k, v]) => [k, String(v)])
  )
}
